import { useEffect, useMemo, useRef } from 'react';

import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { fetchAllProjectCategoriesForChannel } from '@/store/slices/categories';
import { getActiveChannel, selectUserChannel } from '@/store/slices/user/selectors';
import { selectAllProjectCategoriesForChannel } from '@/store/slices/categories/selectors';
import convertProjectTypeBasedOnChannelType from '@/utils/new-project-helpers/convert-project-type-based-on-channel-type';

type TUseLoadChannelProjectCategories = {
  skipIfCategoriesExist?: boolean;
  templatesOnly?: boolean;
};

const useLoadChannelProjectCategories = (props?: TUseLoadChannelProjectCategories) => {
  const { skipIfCategoriesExist, templatesOnly } = props || {};

  const channel = useAppSelector(getActiveChannel);
  const categories = useAppSelector(selectAllProjectCategoriesForChannel);
  const userChannel = useAppSelector(selectUserChannel);

  const dispatch = useAppDispatch();

  const fetched = useRef(false);

  const shouldReturnEarly = useMemo(() => {
    return skipIfCategoriesExist && categories;
  }, [skipIfCategoriesExist, categories]);

  useEffect(() => {
    if (!channel || fetched.current || shouldReturnEarly || !userChannel) {
      return;
    }
    const eventType = convertProjectTypeBasedOnChannelType({ channel: userChannel });
    fetched.current = true;
    dispatch(
      fetchAllProjectCategoriesForChannel({
        channel,
        returnStoreStateIfExists: true,
        templatesOnly,
        eventType,
      })
    );
  }, [channel, dispatch, shouldReturnEarly, templatesOnly, userChannel]);
};

export default useLoadChannelProjectCategories;
